import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb/irb-common/interfaces/grid-layout.service';
import { DeleteSecuritiesSoftDialogComponent } from './delete-securities-soft-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DeleteSecuritySoftDialogGridLayoutService implements GridLayoutService<DeleteSecuritiesSoftDialogComponent> {

  constructor() {}

  getFrameworkComponents() {
    return {};
  }

  getColumnDefs() {
    return [
      {
        headerName: "Symbol",
        field: "securitySymb",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: {
          text: (params: any) => {
            return params.value != null && params.value.length > 0;
          },
        },
        maxWidth: 100
      },
      {
        headerName: "Will no longer be",
        field: "relatedAs",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: {
          text: (params: any) => {
            return params.value != null && params.value.length > 0;
          },
        },
        maxWidth: 125

      },
      {
        headerName: "For this other security/portfolio/account/model",
        field: "relatedToName",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: {
          text: (params: any) => {
            return params.value != null && params.value.length > 0;
          },
        }
        },
    ];
  }
}
